<template>
  <section>
    <gs-header
      title="Sửa role"
      :breadcrumbs="[
        {title: 'Quản lý role', route: {name: 'role'}}
      ]">
    </gs-header>
    <div class="padding-sm-all">
      <el-form :model="localRole" :rules="rules" ref="createRoleForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitRole('createRoleForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localRole.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tên hiển thị">
              <el-input v-model="localRole.display_name" placeholder="Tên hiển thị"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Mô tả">
              <el-input type="textarea" :rows="3" v-model="localRole.description" placeholder="Mô tả"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Tìm kiếm user">
              <el-select class="display-block"
                v-model="suggettionAdmin"
                filterable
                remote
                placeholder="Nhập tên..."
                :remote-method="selectAdmin"
                :loading="fetchAdmin"
                @change="selectSuggettionAdmin"
                >
                <el-option
                  v-for="item in listAdmins"
                  :key="item.id"
                  :value="item">
                  <span class="pull-left text-gray"><i class="fa fa-user"></i>&nbsp;{{ item.name }}</span>
                  <span class="pull-right text-violet"><i class="fa fa-phone"></i>&nbsp;{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
          <el-form-item label="Danh sách users">
            <el-tag
              v-for="admin in selectedAdmins"
              class="margin-sm-right"
              :closable="true"
              type="primary"
              :key="admin.id"
              @close="removeAdmin(admin)"
            >
            {{admin.name}}
            </el-tag>
          </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Permissions">
              <el-row>
                <el-col :span="20" :offset="2">
                  <ul>
                    <li v-for="(gpermission, key, index) in permissions" :key="key">
                      <p class="text-blue text-bold">{{key}}</p>
                      <ul class="permission-subtree">
                          <li v-for="permission in gpermission" :key="key" v-if="fetchData">
                            <el-checkbox @change="selectPermission($event, permission)" :checked="checkIsExist(permission)">{{permission.display_name}}</el-checkbox>
                          </li>
                      </ul>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { getRole, editRole } from 'src/api/roles'
import { head, forEach, findIndex } from 'lodash'
import roleMixin from './mixins'
export default {
  name: 'EditRole',
  mixins: [roleMixin],
  data () {
    return {
      fetchData: false
    }
  },
  methods: {
    validateBeforeSubmitRole () {
      this.submitting = true
      this.$refs.createRoleForm.validate(valid => {
        if (valid) {
          forEach(this.listPermissions, permission => {
            this.localRole.permissions.push(permission.id)
          })
          this.$nextTick(() => {
            this.changedData = false
            editRole(this.localRole.id, this.localRole).then(response => {
              switch (response.code) {
                case 200:
                  this.$store.dispatch('showNotify', {
                    title: 'Sửa thành công',
                    body: 'Sửa role  thành công'
                  })
                  this.reloadGsTableAfterRedirect({name: 'role'}, 'roles')
                  this.toggleLoadding(false)
                  this.submitting = false
                  break
                case 422:
                  let er = response.data.errors
                  let message = head(er[Object.keys(er)[0]])
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: message,
                    type: 'warning'
                  })
                  this.toggleLoadding(false)
                  this.submitting = false
                  break
                default:
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: 'Sửa role thất bại vui lòng kiểm tra lại thông tin',
                    type: 'warning'
                  })
                  this.toggleLoadding(false)
                  this.submitting = false
              }
            })
          })
        } else {
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.submitting = false
          return false
        }
      })
    },
    selectPermission (e, permission) {
      if (e === 1) {
        if (findIndex(this.listPermissions, {id: permission.id}) < 0) {
          this.listPermissions.push({id: permission.id, name: permission.name})
        }
      } else {
        if (e.target.checked) {
          if (findIndex(this.listPermissions, {id: permission.id}) < 0) {
            this.listPermissions.push({id: permission.id, name: permission.name})
          }
        } else {
          this.listPermissions.splice(findIndex(this.listPermissions, {id: permission.id}), 1)
        }
      }
    },
    checkIsExist (permission) {
      if (this.listPermissions.length) {
        let check = findIndex(this.listPermissions, {id: permission.id})
        if (check < 0) {
          return false
        }
        return true
      }
    }
  },
  mounted () {
    getRole(this.$route.params.id, {include: 'users,permissions'}).then(response => {
      if (response.code === 200) {
        this.localRole.id = response.data.id
        this.localRole.name = response.data.name
        this.localRole.display_name = response.data.display_name
        this.localRole.description = response.data.description
        forEach(response.data.users.data, admin => {
          this.localRole.users.push(admin.id)
        })
        forEach(response.data.permissions.data, permission => {
          this.selectPermission(1, permission)
        })
        this.selectedAdmins = response.data.users.data
        this.fetchData = true
        setTimeout(() => {
          this.watching = true
        }, 100)
      } else {
        this.$router.push({name: 'carrier'})
        this.$store.dispatch('showNotify', {
          title: 'Vui lòng kiểm tra thông tin cần nhập',
          body: 'Không tìm thấy tài nguyên',
          type: 'warning'
        })
      }
    })
  }
}
</script>

<style lang="css" scoped>
.permission-subtree {
  list-style: none;
  -moz-column-count: 3;
  -moz-column-gap: 20px;
   -webkit-column-count: 3;
  -webkit-column-gap: 20px;
  column-count: 3;
  column-gap: 20px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// EditRole.vue?ca85b7e4